import React from 'react';
import './Policy.css';

const CancellationPolicy = () => {
  return (
    <div className="policy-page">
      <div className="container">
        <div className="policy-content">
          <h1>Cancellation Policy</h1>
          <p className="last-updated">Last Updated: October 8, 2025</p>

          <section>
            <h2>1. Subscription Cancellation</h2>
            <p>You can cancel your Land Tracker subscription at any time through the App settings or your app store account. Cancellation takes effect at the end of the current billing period.</p>
          </section>

          <section>
            <h2>2. How to Cancel</h2>
            <h3>iOS (App Store)</h3>
            <ul>
              <li>Open Settings on your iPhone/iPad</li>
              <li>Tap your name at the top</li>
              <li>Tap Subscriptions</li>
              <li>Select Land Tracker</li>
              <li>Tap Cancel Subscription</li>
            </ul>

            <h3>Android (Google Play)</h3>
            <ul>
              <li>Open Google Play Store</li>
              <li>Tap Menu → Subscriptions</li>
              <li>Select Land Tracker</li>
              <li>Tap Cancel Subscription</li>
            </ul>

            <h3>Within the App</h3>
            <ul>
              <li>Open Land Tracker app</li>
              <li>Go to Settings → Subscription</li>
              <li>Tap Manage Subscription</li>
              <li>Follow the prompts to cancel</li>
            </ul>
          </section>

          <section>
            <h2>3. When Cancellation Takes Effect</h2>
            <ul>
              <li>Your subscription will remain active until the end of the current billing period</li>
              <li>You will continue to have access to premium features until that date</li>
              <li>No refund will be issued for the remaining days of the billing period</li>
              <li>You will not be charged for subsequent billing periods</li>
            </ul>
          </section>

          <section>
            <h2>4. Free Trial Cancellation</h2>
            <p>If you cancel during a free trial period:</p>
            <ul>
              <li>You must cancel at least 24 hours before the trial ends to avoid charges</li>
              <li>Premium features will be disabled immediately upon cancellation</li>
              <li>You can continue using free features</li>
            </ul>
          </section>

          <section>
            <h2>5. What Happens After Cancellation</h2>
            <div className="highlight-box">
              <p><strong>Your Data is Safe:</strong> All your property data, documents, and information remain stored in your account even after cancellation. You can continue to use the free version of the app with limited features.</p>
            </div>
            <p>Features available after cancellation:</p>
            <ul>
              <li>View your properties (limited to 3)</li>
              <li>Access uploaded documents</li>
              <li>Basic property information</li>
            </ul>
            <p>Features that will be disabled:</p>
            <ul>
              <li>Unlimited property management</li>
              <li>Advanced GPS boundary capture</li>
              <li>Family tree features</li>
              <li>Tax reminder notifications</li>
              <li>Video guide access</li>
              <li>Priority support</li>
            </ul>
          </section>

          <section>
            <h2>6. Reactivating Your Subscription</h2>
            <p>You can reactivate your subscription at any time by:</p>
            <ul>
              <li>Going to Settings → Subscription in the app</li>
              <li>Selecting a subscription plan</li>
              <li>Completing the payment process</li>
            </ul>
            <p>All your previous data will be immediately accessible again.</p>
          </section>

          <section>
            <h2>7. Account Deletion</h2>
            <p>Cancelling your subscription is different from deleting your account. If you want to permanently delete your account and all data:</p>
            <ul>
              <li>Go to Settings → Account → Delete Account</li>
              <li>Confirm your decision (this action cannot be undone)</li>
              <li>All your data will be permanently deleted within 30 days</li>
            </ul>
          </section>

          <section>
            <h2>8. Contact Support</h2>
            <p>If you need help with cancellation or have questions, contact us at:</p>
            <p><strong>Email:</strong> info@landtracker.app</p>
            <p><strong>Response Time:</strong> Within 24 hours</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CancellationPolicy;
